export { renderOptionGroup_unstable as renderOptionGroup } from '@fluentui/react-combobox';
